import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=136311c8&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=tsx&"
export * from "./logList.vue?vue&type=script&lang=tsx&"
import style0 from "./logList.vue?vue&type=style&index=0&id=136311c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136311c8",
  null
  
)

export default component.exports